//cspell:disable
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Useletter from "../Useletter";
import Foter from "../Foter";

function Page1() {
  return (
    <div>
      <Container>
        <Row>
          <Col xs={12}>
            <div
              className="gift"
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              <a
                href="/corporate"
                className="back-button"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  fontSize: "20px",
                }}
              >
                ←
              </a>
              <h2
                style={{
                  fontFamily: "Alata, sans serif",
                  fontSize: "25px",
                  color: "#303030",
                  margin: 0,
                }}
              >
                CORPORATE & GIFTING INQUIRY FORM
              </h2>
            </div>
            <p style={{ paddingLeft: "15px", fontSize: "14px" }}>
              If you need help, please fill out the form below. We will respond
              to every email within 24 hours excluding holidays.
            </p>
          </Col>
        </Row>

        {/* Form + Image */}
        <Row style={{ marginTop: "30px" }}>
          {/* Form Section */}
          <Col xs={12} md={6}>
            <Row>
              <Col xs={12} md={6}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Business Name *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Contact Number *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Country *"
                  />
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your City *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Email *"
                  />
                </div>
                <br />
                <div className="form-group">
                  <select id="category" className="form-control">
                    <option disabled selected value="">
                      Select Category
                    </option>
                    <option value="Apparel">Apparel</option>
                    <option value="Fragrances">Fragrances</option>
                    <option value="Cosmetics">Cosmetics</option>
                    <option value="Gift Box">Gift Box</option>
                  </select>
                </div>
                <br />
                <div className="form-group">
                  <input type="date" className="form-control" />
                </div>
              </Col>

              <Col xs={12}>
                <label
                  htmlFor="inquiry"
                  style={{
                    marginTop: "20px",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Alata, sans serif",
                      fontSize: "14px",
                      color: "#9f9f9f",
                    }}
                  >
                    Inquiry Detail
                  </span>
                </label>
                <textarea
                  id="inquiry"
                  className="form-control"
                  placeholder="Write your text"
                  rows={4}
                ></textarea>
                <br />
                <div>
                  <button
                    className="bt btn btn-dark"
                    type="button"
                    style={{
                      fontFamily: "Alata, sans serif",
                      marginTop: "20px",
                    }}
                  >
                    SUBMIT
                  </button>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Image Section */}
          <Col xs={12} md={6}>
            <div
              className="Ima"
              style={{ marginTop: "30px", textAlign: "center" }}
            >
              <img
                style={{ width: "100%", height: "auto", maxWidth: "500px" }}
                src="https://www.junaidjamshed.com/media/CorporateImages/default/corporate.jpg"
                alt=""
              />
            </div>
          </Col>
        </Row>
      </Container>

      <Useletter />
      <Foter />
    </div>
  );
}

export default Page1;
